export const emailRegexRule =
  /^[a-zA-Z0-9]+([._+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,})+$/;

export const isEmailValid = (value: string) => emailRegexRule.test(value);
